// The guided tour of the demo league: the way in from the landing page.
//
// A visitor who taps "Take the tour" is walked through the main features
// page by page, Home, Lineup, Scoreboard, League, Teams, ending at Sign up.
// Each page's own tour runs as normal; in guided mode its last step carries
// the visitor on to the next page instead of closing (usePageTour).
//
// The state is one flag in sessionStorage: it lasts the visit and no longer,
// so a visitor who leaves and comes back through the landing page starts
// fresh. Closing any step ends it, and they are free to look around.
const KEY = "demoTour:guided";

// Called from the landing page link. Clears the demo's "seen" marks too, so
// every page's tour runs again on this pass however often the device has
// been through the demo before.
export function startGuidedDemo() {
  try {
    window.sessionStorage.setItem(KEY, "1");
    Object.keys(window.localStorage)
      .filter((k) => k.startsWith("tour:demo:"))
      .forEach((k) => window.localStorage.removeItem(k));
  } catch { /* storage unavailable: the tours still run, unchained */ }
}

export function isGuidedDemo() {
  try { return window.sessionStorage.getItem(KEY) === "1"; } catch { return false; }
}

export function endGuidedDemo() {
  try { window.sessionStorage.removeItem(KEY); } catch { /* unavailable */ }
}
